module.exports = __webpack_public_path__ + "img/1185x407px.53c53b5e.jpg";